<template>

  <header class="flex flex-col items-center">
    <img class="object-contain w-full" src="@/assets/header.jpg" />
  </header>

  <div class="w-full flex flex-col items-center justify-center py-8 bg-white">
    <div class="flex flex-col md:flex-row w-full md:w-auto gap-2 md:gap-4 px-5 text-center">
      <router-link to="/" class="bg-[#175c8c] hover:bg-[#0f3449] text-white px-4 py-2 rounded-md transition-all duration-200" >
        <i class="pi pi-check mr-2"></i>SOY INVITADO
      </router-link>
      <router-link to="/prensa" class="bg-[#175c8c] hover:bg-[#0f3449] text-white px-4 py-2 rounded-md transition-all duration-200" >
        <i class="pi pi-check mr-2"></i>SOY PRENSA
      </router-link>
      <router-link to="/credenciales" class="bg-[#175c8c] hover:bg-[#0f3449] text-white px-4 py-2 rounded-md transition-all duration-200" >
        <i class="pi pi-check mr-2"></i>YA ME ACREDITÉ
      </router-link>
    </div>

  </div>
  <div class="h-2 bg-[#249c38]"></div>
  
  


</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>